/**
 * Cloud access for `tax_estimates` <- localStorage `taxPlanEstimates`
 * (unprefixed key). Frozen Tax Harvest Estimator snapshots. All monetary values
 * are AUD (the estimator is AUD-denominated) — currency is implicit, no column.
 * No CHECK constraints on this table.
 */
import type { TaxPlanEstimate } from '../../hooks/useTaxPlan';
import type { TaxEstimateRow } from './rows';
import { makeAppendTable } from './client';

function toRow(e: TaxPlanEstimate, userId: string): TaxEstimateRow {
  return {
    id: e.id,
    user_id: userId,
    coin_id: e.coinId,
    coin_name: e.coinName,
    coin_ticker: e.coinTicker,
    coin_image: e.coinImage ?? null,
    amount_to_sell: e.amountToSell,
    cost_basis: e.costBasis,
    estimated_sale_price: e.estimatedSalePrice,
    hold_duration_months: e.holdDurationMonths,
    cgt_discount_applied: e.cgtDiscountApplied,
    capital_gain: e.capitalGain,
    tax_bracket: e.taxBracket,
    tax_bracket_rate: e.taxBracketRate,
    estimated_cgt: e.estimatedCGT,
    saved_at: e.savedAt,
    scenario_name: e.scenarioName,
  };
}

function fromRow(row: TaxEstimateRow): TaxPlanEstimate {
  return {
    id: row.id,
    coinId: row.coin_id,
    coinName: row.coin_name,
    coinTicker: row.coin_ticker,
    ...(row.coin_image != null ? { coinImage: row.coin_image } : {}),
    amountToSell: Number(row.amount_to_sell),
    costBasis: Number(row.cost_basis),
    estimatedSalePrice: Number(row.estimated_sale_price),
    holdDurationMonths: Number(row.hold_duration_months),
    cgtDiscountApplied: Boolean(row.cgt_discount_applied),
    capitalGain: Number(row.capital_gain),
    taxBracket: row.tax_bracket,
    taxBracketRate: Number(row.tax_bracket_rate),
    estimatedCGT: Number(row.estimated_cgt),
    savedAt: row.saved_at,
    scenarioName: row.scenario_name,
  };
}

export const taxEstimatesTable = makeAppendTable<TaxPlanEstimate, TaxEstimateRow>(
  'tax_estimates',
  toRow,
  fromRow
);
